// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/generations/v1/set_generation_crop.proto (package protos.vision.generations.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { GenerationCrop } from "./generation_crop_pb";
import { file_vision_generations_v1_generation_crop } from "./generation_crop_pb";
import type { VisionGeneration } from "./vision_generation_pb";
import { file_vision_generations_v1_vision_generation } from "./vision_generation_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/generations/v1/set_generation_crop.proto.
 */
export const file_vision_generations_v1_set_generation_crop: GenFile = /*@__PURE__*/
  fileDesc("Ci92aXNpb24vZ2VuZXJhdGlvbnMvdjEvc2V0X2dlbmVyYXRpb25fY3JvcC5wcm90bxIccHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MSLGAQoYU2V0R2VuZXJhdGlvbkNyb3BSZXF1ZXN0Ek0KBnBhcmFtcxgBIAEoCzI9LnByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEuU2V0R2VuZXJhdGlvbkNyb3BSZXF1ZXN0LlBhcmFtcxpbCgZQYXJhbXMSFQoNZ2VuZXJhdGlvbl9pZBgBIAEoCRI6CgRjcm9wGAIgASgLMiwucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5HZW5lcmF0aW9uQ3JvcCK5AQoZU2V0R2VuZXJhdGlvbkNyb3BSZXNwb25zZRJOCgZyZXN1bHQYASABKAsyPi5wcm90b3MudmlzaW9uLmdlbmVyYXRpb25zLnYxLlNldEdlbmVyYXRpb25Dcm9wUmVzcG9uc2UuUmVzdWx0GkwKBlJlc3VsdBJCCgpnZW5lcmF0aW9uGAEgASgLMi4ucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5WaXNpb25HZW5lcmF0aW9uYgZwcm90bzM", [file_vision_generations_v1_generation_crop, file_vision_generations_v1_vision_generation]);

/**
 * @generated from message protos.vision.generations.v1.SetGenerationCropRequest
 */
export type SetGenerationCropRequest = Message<"protos.vision.generations.v1.SetGenerationCropRequest"> & {
  /**
   * @generated from field: protos.vision.generations.v1.SetGenerationCropRequest.Params params = 1;
   */
  params?: SetGenerationCropRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.SetGenerationCropRequest.
 * Use `create(SetGenerationCropRequestSchema)` to create a new message.
 */
export const SetGenerationCropRequestSchema: GenMessage<SetGenerationCropRequest> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_set_generation_crop, 0);

/**
 * @generated from message protos.vision.generations.v1.SetGenerationCropRequest.Params
 */
export type SetGenerationCropRequest_Params = Message<"protos.vision.generations.v1.SetGenerationCropRequest.Params"> & {
  /**
   * @generated from field: string generation_id = 1;
   */
  generationId: string;

  /**
   * @generated from field: protos.vision.generations.v1.GenerationCrop crop = 2;
   */
  crop?: GenerationCrop | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.SetGenerationCropRequest.Params.
 * Use `create(SetGenerationCropRequest_ParamsSchema)` to create a new message.
 */
export const SetGenerationCropRequest_ParamsSchema: GenMessage<SetGenerationCropRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_set_generation_crop, 0, 0);

/**
 * @generated from message protos.vision.generations.v1.SetGenerationCropResponse
 */
export type SetGenerationCropResponse = Message<"protos.vision.generations.v1.SetGenerationCropResponse"> & {
  /**
   * @generated from field: protos.vision.generations.v1.SetGenerationCropResponse.Result result = 1;
   */
  result?: SetGenerationCropResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.SetGenerationCropResponse.
 * Use `create(SetGenerationCropResponseSchema)` to create a new message.
 */
export const SetGenerationCropResponseSchema: GenMessage<SetGenerationCropResponse> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_set_generation_crop, 1);

/**
 * @generated from message protos.vision.generations.v1.SetGenerationCropResponse.Result
 */
export type SetGenerationCropResponse_Result = Message<"protos.vision.generations.v1.SetGenerationCropResponse.Result"> & {
  /**
   * @generated from field: protos.vision.generations.v1.VisionGeneration generation = 1;
   */
  generation?: VisionGeneration | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.SetGenerationCropResponse.Result.
 * Use `create(SetGenerationCropResponse_ResultSchema)` to create a new message.
 */
export const SetGenerationCropResponse_ResultSchema: GenMessage<SetGenerationCropResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_set_generation_crop, 1, 0);

